import React from 'react'
import { NavLink } from "react-router-dom";

const TrainingCard = ({src,alt,title,text,link}) => {
  return (
    <>
                  <div className="card3">
                    <div className="card3-image-container">
                      <img src={src} alt={alt} />
                    </div>
                    <div className="card3-content">
                      <h3>{title}</h3>
                      <p>
                        {text}
                      </p>
                      <NavLink className={'cta'} to={link}>Know More...</NavLink>
                    </div>
                  </div>
                </>
  )
}

export default TrainingCard;